import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog';
import { X, Plus } from 'lucide-react';

export const EntityAdminsModal = ({
  open,
  onOpenChange,
  selectedEntity,
  users,
  selectedEntityAdmins,
  entityAdminSearch,
  setEntityAdminSearch,
  onToggleEntityAdmin,
  onAssign,
}) => {
  const search = entityAdminSearch.toLowerCase();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Manage Partner Admins</DialogTitle>
          <DialogDescription>
            Assign up to 2 users who can manage {selectedEntity?.name}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label>Search Users</Label>
            <Input
              placeholder="Search by name or email..."
              value={entityAdminSearch}
              onChange={(e) => setEntityAdminSearch(e.target.value)}
            />
          </div>

          <div className="space-y-2">
            <Label>Selected Admins ({selectedEntityAdmins.length}/2)</Label>
            {selectedEntityAdmins.length === 0 ? (
              <p className="text-sm text-muted-foreground">No entity admins assigned</p>
            ) : (
              <div className="space-y-2">
                {users
                  .filter((u) => selectedEntityAdmins.includes(u.user_id))
                  .map((u) => (
                    <div key={u.user_id} className="flex items-center justify-between p-2 rounded-lg bg-muted/50">
                      <div className="flex items-center gap-2">
                        {u.picture && <img src={u.picture} alt={u.name} className="w-8 h-8 rounded-full" />}
                        <div>
                          <p className="font-medium text-sm">{u.name}</p>
                          <p className="text-xs text-muted-foreground">{u.email}</p>
                        </div>
                      </div>
                      <Button variant="ghost" size="sm" onClick={() => onToggleEntityAdmin(u.user_id)}>
                        <X className="h-4 w-4" />
                      </Button>
                    </div>
                  ))}
              </div>
            )}
          </div>

          <div className="space-y-2">
            <Label>Available Users</Label>
            <div className="max-h-64 overflow-y-auto space-y-1 border rounded-lg p-2">
              {users
                .filter(
                  (u) =>
                    !selectedEntityAdmins.includes(u.user_id) &&
                    (u.name.toLowerCase().includes(search) || u.email.toLowerCase().includes(search))
                )
                .map((u) => (
                  <div
                    key={u.user_id}
                    className="flex items-center justify-between p-2 rounded hover:bg-muted/50 cursor-pointer"
                    onClick={() => onToggleEntityAdmin(u.user_id)}
                  >
                    <div className="flex items-center gap-2">
                      {u.picture && <img src={u.picture} alt={u.name} className="w-8 h-8 rounded-full" />}
                      <div>
                        <p className="font-medium text-sm">{u.name}</p>
                        <p className="text-xs text-muted-foreground">{u.email}</p>
                      </div>
                    </div>
                    <Button variant="ghost" size="sm" disabled={selectedEntityAdmins.length >= 2}>
                      <Plus className="h-4 w-4" />
                    </Button>
                  </div>
                ))}
            </div>
          </div>

          <div className="text-xs text-muted-foreground p-3 rounded-lg bg-muted/30">
            <p>
              <strong>Partner Admins</strong> can edit and manage this specific partner's information, gallery, promo codes, and offers.
            </p>
            <p className="mt-1">Maximum 2 entity admins allowed per entity.</p>
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={onAssign}>Save Partner Admins</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default EntityAdminsModal;
